import { getFetch } from '../fetch';

import { apiConfig } from '../config';
import { buildUrlWithQueryParams } from '../utils/buildUrlWithQueryParams';

interface SpecialLessonAwardStudentData {
    firstName: string;
    lastName: string;
    teamName: string;
    studentId: number;
    lessonId: number;
    points: number;
    maxPoints: number;
    awardStatus: string;
}
interface GetSpecialLessonAwardsResponse {
    studentsData: SpecialLessonAwardStudentData[];
}

export function getSpecialLessonAwards(metaSlug: string): Promise<GetSpecialLessonAwardsResponse> {
    const { apiGetSpecialLessonAwards } = apiConfig.getStaticUrls();

    const url = buildUrlWithQueryParams(apiGetSpecialLessonAwards, { meta_slug: metaSlug });
    return getFetch(url);
}
